import { useMemo } from 'react'

import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import {
  useAPIGetSummary,
  useAPIGetStatus,
} from 'api/kinerja/penilik-pegawai/overview'
import { useAPIGetPerencanaanSummary } from 'api/kinerja/penilik-pegawai/perencanaan'

export function usePenilikSummary({
  disabled = false,
}: {
  disabled?: boolean
} = {}) {
  const { period, isHavePeriod } = usePeriodContext()

  const { data: summary, status: summaryFetchStatus } = useAPIGetSummary({
    periodId: period.id,
    enabled: !disabled && isHavePeriod,
  })
  const isPelaksanaanState = ['PELAKSANAAN_DIMULAI'].includes(
    summary?.perencanaanStatus
  )

  // E-Kinerja Sync
  const isEkinSyncSuccess = ['RHK_CREATED', 'PERSETUJUAN_SUCCESS'].includes(
    summary?.ekinSyncStatus
  )
  const ekinSyncAt = useMemo(() => {
    if (
      !summary?.ekinSyncAt ||
      summary?.ekinSyncAt === '0001-01-01T00:00:00Z'
    ) {
      return null
    }

    return summary?.ekinSyncAt
  }, [summary?.ekinSyncAt])

  return {
    summary,
    summaryFetchStatus,
    isPelaksanaanState,
    isEkinSyncSuccess,
    ekinSyncAt,
  }
}

export function usePenilikStatus({
  disabled = false,
}: {
  disabled?: boolean
} = {}) {
  const { period, isHavePeriod } = usePeriodContext()

  const { data: summary, status: summaryFetchStatus } = useAPIGetStatus({
    periodId: period.id,
    enabled: !disabled && isHavePeriod,
  })
  const isPelaksanaanState = ['PELAKSANAAN_DIMULAI'].includes(
    summary?.perencanaanStatus
  )

  return {
    summary,
    summaryFetchStatus,
    isPelaksanaanState,
  }
}

export function usePerencanaanPenilikSummary() {
  const { period, isHavePeriod } = usePeriodContext()
  const { data: { data: perencanaan } = {}, status: apiStatus } =
    useAPIGetPerencanaanSummary({
      periodId: period.id,
      enabled: isHavePeriod,
    })
  return {
    perencanaan,
    apiStatus,
  }
}
